import axios from "axios"
import {KEY_TOKEN} from "@/config"
import store from "@/store";
import {Toast} from "vant";
import router from "@/router";
import i18n from "../i18n";

const TIME_ZONE = "timeZone";
const LANGUAGE = "languages";
const TOKEN = "front-token";

const service = axios.create({
  baseURL: process.env.NODE_ENV === "dev" ? "/api" : process.env.VUE_APP_BASE_API,
  timeout: 10000, withCredentials: true,
})

service.interceptors.request.use(request => {
  if (request.data && request.data.showProgress) {
    Toast.loading({
      duration: 0,
      message: i18n.t("Application.Waiting"),
      forbidClick: true
    });
  } else if (!request.data) {
    Toast.loading({
      duration: 0,
      message:  i18n.t("Application.Waiting"),
      forbidClick: true
    });
  }
  let timezone = new Date().getTimezoneOffset() / -60;
  if (timezone > 0) {
    timezone = `+${timezone}:00`;
  } else {
    timezone = `${timezone}:00`;
  }
  request.headers[TIME_ZONE] = timezone;
  request.headers[LANGUAGE] = navigator.language.includes('zh') ? 1 : 0;
  let token = localStorage.getItem(KEY_TOKEN);
  if (token) {
    request.headers[TOKEN] = token;
  }
  return request;
})

service.interceptors.response.use(response => {
  if (response.config.data && !(response.config.data instanceof FormData)) {

    let json = JSON.parse(response.config.data);
    if (json.showProgress) {
      Toast.clear();
    }
  } else {
    Toast.clear();
  }

  if (response.data.code === 200) {
    return Promise.resolve(response.data);
  }
  if (response.data.code === 401) {
    store.commit('user/setToken', null);
    store.commit('user/setUserInfo', null);
    localStorage.clear();
    router.push({
      path: 'login',
      query: {
        redirect: router.currentRoute.fullPath
      }
    })
    Toast({
      message: response.data.message
    })
  }
  return Promise.reject(response.data.message);
}, error => {
  console.log(error);
  return Promise.reject('Network error');
})


export async function requestGet(url, params) {
  const response = await service(url, {
    params: params,
  });
  return response;
}

export async function requestPost(url, data = {}) {
  const response = await service(url, {
    method: 'post',
    data: data,
  })
  return response;
}


export async function requestUploadFile(url, file = {}) {
  const formData = new FormData();
  formData.append('file', file);
  const response = await service(url, {
    method: 'post', data: formData, header: {
      'Content-Type': 'multipart/form-data',
    }
  });
  return response;
}
